import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { color, opacity, spacing, variant, themeMode, palette, baseUnit } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { DismissButton } from '../DismissButton/DismissButton.es.js';
var paletteStyles = {
  base: variant({
    prop: "palette",
    compoundProp: "kind",
    variants: {
      default: {
        outline: {
          borderColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          backgroundColor: "transparent",
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        },
        solid: {
          borderColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          backgroundColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        }
      },
      secondary: {
        outline: {
          borderColor: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          }),
          backgroundColor: "transparent",
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        },
        solid: {
          borderColor: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          }),
          backgroundColor: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          }),
          color: themeMode({
            light: palette("neutral.50"),
            dark: palette("neutral.900")
          })
        }
      }
    }
  }),
  hover: variant({
    prop: "palette",
    compoundProp: "kind",
    variants: {
      default: {
        outline: {
          borderColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          backgroundColor: themeMode({
            light: palette("neutral.100"),
            dark: palette("neutral.800")
          }),
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        },
        solid: {
          borderColor: themeMode({
            light: palette("neutral.300"),
            dark: palette("neutral.500")
          }),
          backgroundColor: themeMode({
            light: palette("neutral.300"),
            dark: palette("neutral.500")
          }),
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        }
      },
      secondary: {
        outline: {
          borderColor: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          }),
          backgroundColor: themeMode({
            light: palette("neutral.600"),
            dark: palette("neutral.300")
          }),
          color: themeMode({
            light: palette("neutral.50"),
            dark: palette("neutral.900")
          })
        },
        solid: {
          borderColor: themeMode({
            light: palette("neutral.700"),
            dark: palette("neutral.200")
          }),
          backgroundColor: themeMode({
            light: palette("neutral.700"),
            dark: palette("neutral.200")
          }),
          color: themeMode({
            light: palette("neutral.50"),
            dark: palette("neutral.900")
          })
        }
      }
    }
  }),
  disabled: variant({
    prop: "palette",
    compoundProp: "kind",
    variants: {
      default: {
        outline: {
          borderColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          backgroundColor: "transparent",
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        },
        solid: {
          borderColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          backgroundColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        }
      },
      secondary: {
        outline: {
          borderColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          backgroundColor: "transparent",
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        },
        solid: {
          borderColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          backgroundColor: themeMode({
            light: palette("neutral.200"),
            dark: palette("neutral.700")
          }),
          color: themeMode({
            light: palette("neutral.900"),
            dark: palette("neutral.50")
          })
        }
      }
    }
  }),
  error: variant({
    prop: "palette",
    variants: {
      default: {
        borderColor: themeMode({
          light: palette("danger.500"),
          dark: palette("danger.500")
        })
      },
      secondary: {
        borderColor: themeMode({
          light: palette("danger.500"),
          dark: palette("danger.500")
        })
      }
    }
  })
};
var sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "md",
      height: baseUnit(6),
      py: 0,
      px: "xxs"
    },
    md: {
      fontSize: "md",
      height: baseUnit(9),
      py: 0,
      px: "xs"
    },
    lg: {
      fontSize: "lg",
      height: baseUnit(12),
      py: 0,
      px: "sm"
    }
  }
});
var shapeStyles = variant({
  prop: "shape",
  variants: {
    default: {
      borderRadius: "sm"
    },
    rounded: {
      borderRadius: "round"
    }
  }
});
var showDismissStyles = variant({
  prop: "showDismiss",
  compoundProp: "size",
  variants: {
    true: {
      sm: {
        paddingRight: "xxs"
      }
    }
  }
});
var Chip = styled(Box).attrs(function (_ref) {
  var onClick = _ref.onClick,
      isDisabled = _ref.isDisabled,
      isChecked = _ref.isChecked,
      isLoading = _ref.isLoading;
  return {
    "aria-disabled": isDisabled || isLoading,
    disabled: isDisabled || isLoading,
    "aria-pressed": onClick ? isChecked : null,
    "aria-busy": isLoading,
    role: onClick ? "button" : null
  };
}).withConfig({
  componentId: "iwn7ih-0"
})(["display:inline-flex;flex-direction:row;justify-content:center;align-content:center;align-items:center;user-select:none;background-color:transparent;border:1px solid transparent;color:", ";", ";", ";", ";", ";", ";", ";", ""], color("text.base"), paletteStyles.base, sizeStyles, shapeStyles, showDismissStyles, function (_ref2) {
  var onClick = _ref2.onClick;
  return !!onClick && css(["cursor:pointer;&:hover{", ";}&[aria-disabled='true']{pointer-events:none;opacity:", ";", ";}"], paletteStyles.hover, opacity("subtle"), paletteStyles.disabled);
}, function (_ref3) {
  var isError = _ref3.isError;
  return !!isError && css(["", ";"], paletteStyles.error);
}, function (_ref4) {
  var isMultiline = _ref4.isMultiline;
  return isMultiline && css(["margin:", ";"], spacing("xxs"));
});
var Dismiss = styled(DismissButton).withConfig({
  componentId: "iwn7ih-1"
})(["&,&:hover{transition:none;color:currentColor;background-color:transparent;text-decoration:none;}"]);
var Label = styled(Box).withConfig({
  componentId: "iwn7ih-2"
})(["display:flex;width:100%;padding:0 ", ";"], spacing("xxs"));
export { Chip, Dismiss, Label };